import { render } from "./NewCourse.vue?vue&type=template&id=1e39beb0&scoped=true&ts=true"
import script from "./NewCourse.vue?vue&type=script&lang=ts"
export * from "./NewCourse.vue?vue&type=script&lang=ts"

import "./NewCourse.vue?vue&type=style&index=0&id=1e39beb0&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e39beb0"]])

export default __exports__